import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormActivityFilter, { FORM_ACTIVITY_FILTER_ID } from '../forms/FormActivityFilter';
import { useTranslation } from 'react-i18next';

export default function SheetActivityFilter({ open, onClose, collaborators, onSubmit, currentFilter, resetKey }) {
    const { t } = useTranslation();
    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0">
                <SheetHeader className="px-6 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{t('account:filtrerParCollaborateur')}</SheetTitle>
                </SheetHeader>

                <FormActivityFilter
                    collaborators={collaborators}
                    onSubmit={onSubmit}
                    currentFilter={currentFilter}
                    onReset={resetKey}
                />

                <SheetFooter className="px-6 py-4 border-t border-border">
                    <SubmitButton form={FORM_ACTIVITY_FILTER_ID} className="w-full px-4 py-3 rounded-lg">
                        {t('account:appliquer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
